// Organisation route paths (UNIVAPLAT-3666). Leaf module: no imports, so pages, the sidebar and
// the route table can all depend on it without a cycle.
export const ORGANISATIONS_LIST_ROUTE = 'cdss/admin/organisations';
export const ORGANISATION_NEW_ROUTE = 'cdss/admin/organisations/new';
export const ORGANISATION_DETAIL_ROUTE = 'cdss/admin/organisations/:id';
export const organisationDetailRoute = (id: number | string): string => `${ORGANISATIONS_LIST_ROUTE}/${id}`;
